import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components';
import useBulkProposeAllocationsForResourceRequest from '~/modules/resourcing/common/hooks/useBulkProposeAllocationsForResourceRequest';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2, 1, 1.5),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none',
    zIndex: 5
  },
  root2: {
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none'
  },
  text: {
    textTransform: 'uppercase'
  },
  delaStarIcon: {
    color: theme.palette.common.white,
    fontSize: theme.spacing(1.75),
    marginRight: theme.spacing(0.5)
  }
}));

export const ResourceRequestProposeAllButton = ({
  submittedResourceRequestUrisWithMatches
}) => {
  const classes = useStyles();
  const {
    bulkProposeAllocationsForResourceRequest
  } = useBulkProposeAllocationsForResourceRequest();

  const handleSubmitAll = useCallback(() => {
    bulkProposeAllocationsForResourceRequest({
      submittedResourceRequestsWithMatches: submittedResourceRequestUrisWithMatches.map(
        ({ resourceRequest, userIds }) => ({
          resourceRequest,
          userIds: userIds || []
        })
      )
    });
  }, [
    bulkProposeAllocationsForResourceRequest,
    submittedResourceRequestUrisWithMatches
  ]);

  return (
    <Button
      className={classes.root2}
      onClick={handleSubmitAll}
      variant="contained"
    >
      <DelaStarIcon className={classes.delaStarIcon} />
      <FormattedMessage
        className={classes.text}
        id="resourceRequestChartBanner.proposeAll"
      />
    </Button>
  );
};

ResourceRequestProposeAllButton.propTypes = {
  submittedResourceRequestUrisWithMatches: PropTypes.array.isRequired
};

export default ResourceRequestProposeAllButton;
